<footer class="footer">
    <div class="container">
      <span class="text-muted">Your Content Here</span>
    </div>
  </footer>
  